import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

// Generic "export rows to .xlsx" helper shared by list pages. Takes plain
// row objects (already the shape you want in the sheet — flatten/format
// fields before calling this) and triggers a browser download.
export function exportToExcel(rows, filename, sheetName = 'Sheet1', colWidths = null) {
  if (!rows || rows.length === 0) {
    return false;
  }
  const worksheet = XLSX.utils.json_to_sheet(rows);
  if (Array.isArray(colWidths)) {
    worksheet['!cols'] = colWidths.map((wch) => ({ wch }));
  }
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
  const buffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
  const blob = new Blob([buffer], { type: 'application/octet-stream' });
  const stamp = new Date().toISOString().slice(0, 10);
  saveAs(blob, `${filename}-${stamp}.xlsx`);
  return true;
}

// Same rows → .csv. Prefixed with a UTF-8 BOM so Excel shows "₹" and other
// non-ASCII text correctly when the file is double-clicked.
export function exportToCsv(rows, filename) {
  if (!rows || rows.length === 0) {
    return false;
  }
  const worksheet = XLSX.utils.json_to_sheet(rows);
  const csv = XLSX.utils.sheet_to_csv(worksheet);
  const blob = new Blob(['\uFEFF' + csv], { type: 'text/csv;charset=utf-8' });
  const stamp = new Date().toISOString().slice(0, 10);
  saveAs(blob, `${filename}-${stamp}.csv`);
  return true;
}
